export const USD_DIFFERENCE_PLACEHOLDER = ''
export const USD_VALUE_PLACEHOLDER = ''

export const DATA_PLACEHOLDER = '−'
